var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"informatiton"},[_c('el-image',{staticStyle:{"width":"261px","height":"201px"},attrs:{"src":_vm.src}}),_vm._m(0)],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt20"},[_c('span',{staticClass:"red"},[_vm._v("抱歉，")]),_vm._v("暂无相关信息。")])
}]

export { render, staticRenderFns }